export const TEAM_ROLES = {
    SUPER_ADMIN: "SUPER_ADMIN",
    SUPPORT: "SUPPORT"
}
export const SCHOOL_ROLES = {
    SCHOOL_ADMIN : "SCHOOL_ADMIN",
    ADMIN: "ADMIN",
    PRINCIPAL: "PRINCIPAL",
    TEACHER: "TEACHER",
    STUDENT: "STUDENT",
    STAFF: "STAFF"
}

export const USER_ROLES = {
    ...TEAM_ROLES,
    ...SCHOOL_ROLES
}
export const ROLES = {
    ADMIN: "ADMIN",
    SCHOOL_ADMIN: "SCHOOL_ADMIN",
    PRINCIPAL: "PRINCIPAL",
    TEACHER: "TEACHER",
    STUDENT: "STUDENT"
}
export const VALUE_FORMAT = {
    INT: "int",
    STRING: "string",
    BOOLEAN: "boolean"
}

export const FEES_TYPE = Object.freeze({
    TUITION: "TUITION",
    EXAMINATION: "EXAMINATION",
    TRANSPORT: "TRANSPORT",
    LIBRARY: "LIBRARY",
    SPORTS: "SPORTS",
    LAB: "LAB",
    OTHER: "OTHER"
});

export const FREQUENCY = Object.freeze({
    MONTHLY: "Monthly Fee",
    ONCE: "One time Fee",
    QUARTERLY: "Quarterly Fee",
    HALF_YEARLY: "Half yearly Fee",
    YEARLY: "Yearly Fee"
});

export const ACADEMIC_YEAR = Object.freeze({
    1: "2024-2025",
    2: "2025-2026",
    3: "2026-2027"
})

export const ATTENDANCE_TYPE = Object.freeze({
    PRESENT: "PRESENT",
    ABSENT: "ABSENT",
    LATE: "LATE",
    HALF_DAY: "HALF_DAY",
    SICK: "SICK",
    ON_LEAVE: "ON_LEAVE",
    EXCUSED: "EXCUSED",
    PENDING: "PENDING"
});

export const MONTH_NAME = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sept", "Oct", "Nov", "Dec"];
// ─── Constants ────────────────────────────────────────────────────────────────
export const MONTH_NAME_FULL = [
  'January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December'
];

export const FEE_TYPES = [
  { value: 'TUITION', label: 'Tuition Fee' },
  { value: 'TRANSPORT', label: 'Transport Fee' },
  { value: 'EXAM', label: 'Exam Fee' },
  { value: 'LIBRARY', label: 'Library Fee' },
  { value: 'LAB', label: 'Lab Fee' },
];

export const PAYMENT_METHODS = [
  { value: 'CASH', label: 'Cash' },
  { value: 'CARD', label: 'Card' },
  { value: 'ONLINE', label: 'Online' },
  { value: 'CHEQUE', label: 'Cheque' },
  { value: 'UPI', label: 'UPI' },
];

export const ONLINE_METHODS = ['ONLINE', 'UPI', 'CARD'];

export const eventType = {
        'HOLIDAY': 'holiday',
        'EXAM': 'exam',
        'ASSIGNMENT': 'academic',
        'MEETING': 'meeting',
        'SPORTS': 'activity',
        'CULTURAL': 'activity',
        'PARENTS_MEETING': 'meeting',
        'WORKSHOP': 'academic',
        'FIELD_TRIP': 'activity',
        'ANNOUNCEMENT': 'event',
        'OTHER': 'event'
    };
// Map backend event types to calendar display types
export const mapEventType = (backendType) => {
   
    return eventType[backendType] || 'event';
};

// Permission constants
export const PERMISSIONS = {
    // Student permissions
    STUDENT_VIEW_ALL: 'STUDENT_VIEW_ALL',
    STUDENT_VIEW_CLASS: 'STUDENT_VIEW_CLASS',
    STUDENT_ADD: 'STUDENT_ADD',
    STUDENT_EDIT: 'STUDENT_EDIT',
    STUDENT_DELETE: 'STUDENT_DELETE',
    STUDENT_PROMOTE: 'STUDENT_PROMOTE',

    // Staff/Teacher permissions
    STAFF_VIEW_ALL: 'STAFF_VIEW_ALL',
    STAFF_ADD: 'STAFF_ADD',
    STAFF_EDIT: 'STAFF_EDIT',
    STAFF_DELETE: 'STAFF_DELETE',
    STAFF_ASSIGN_CLASSES: 'STAFF_ASSIGN_CLASSES',

    // Academic permissions
    ACADEMIC_VIEW_ATTENDANCE: 'ACADEMIC_VIEW_ATTENDANCE',
    ACADEMIC_MARK_ATTENDANCE: 'ACADEMIC_MARK_ATTENDANCE',
    ACADEMIC_VIEW_GRADES: 'ACADEMIC_VIEW_GRADES',
    ACADEMIC_ENTER_GRADES: 'ACADEMIC_ENTER_GRADES',
    ACADEMIC_VIEW_REPORTS: 'ACADEMIC_VIEW_REPORTS',

    // Fee permissions
    FEE_VIEW_ALL: 'FEE_VIEW_ALL',
    FEE_COLLECT: 'FEE_COLLECT',
    FEE_VIEW_REPORTS: 'FEE_VIEW_REPORTS',

    // Communication permissions
    COMM_SEND_NOTICE: 'COMM_SEND_NOTICE',
    COMM_SEND_SMS: 'COMM_SEND_SMS',

    // Library permissions
    LIBRARY_VIEW_RECORDS: 'LIBRARY_VIEW_RECORDS',
    LIBRARY_ISSUE_BOOKS: 'LIBRARY_ISSUE_BOOKS',
    LIBRARY_MANAGE_BOOKS: 'LIBRARY_MANAGE_BOOKS',

    // System permissions
    SYSTEM_CONFIG: 'SYSTEM_CONFIG',
    SYSTEM_USER_MANAGEMENT: 'SYSTEM_USER_MANAGEMENT',
      SYSTEM_USER_CHANGE_PASSWORD: "SYSTEM_USER_CHANGE_PASSWORD", // Reset user passwords

    // Billing administration permissions
    BILLING_VIEW: 'BILLING_VIEW',
    BILLING_MANAGE: 'BILLING_MANAGE',
    BILLING_REFUND: 'BILLING_REFUND',

    // Transport permissions
    TRANSPORT_MANAGE_ROUTES: 'TRANSPORT_MANAGE_ROUTES',
};

export const EDUCATION_BOARDS = ['CBSE', 'ICSE', 'STATE_BOARD', 'IB', 'IGCSE', 'OTHER'];
export const SCHOOL_TYPES = ['GOVERNMENT','PRIVATE','PRIVATE_AIDED','KENDRIYA_VIDYALAYA','NAVODAYA_VIDYALAYA','SAINIK_SCHOOL','INTERNATIONAL'];
export const SCHOOL_SUB_TYPES = ['PRIMARY', 'SECONDARY', 'SENIOR_SECONDARY', 'COMPOSITE', 'RESIDENTIAL'];
export const SCHOOL_STATUSES = ['ACTIVE', 'INACTIVE', 'SUSPENDED', 'TRIAL'];
export const GENDERS = ['MALE', 'FEMALE', 'OTHER'];
export const INSTITUTION_TYPES = ['SCHOOL',  'INSTITUTE'];
export const BLOOD_GROUPS = [{key : "A_POSITIVE", value : "A+"}, {key : "A_NEGATIVE", value : "A-"}, {key : "B_POSITIVE", value : "B+"}, {key : "B_NEGATIVE", value : "B-"}, {key : "AB_POSITIVE", value : "AB+"}, {key : "AB_NEGATIVE", value : "AB-"}, {key : "O_POSITIVE", value : "O+"}, {key : "O_NEGATIVE", value : "O-"}];